import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import * as ROUTES from '@constants/routes';

import type { ObservationRecord } from '@models/observation';

import ObservationTracker from '../ObservationTracker/ObservationTracker';

const messages = defineMessages({
  fitness: {
    id: 'dashboardFitness.fitness',
    defaultMessage: 'Recent Daily Stats',
  },
  noFitness: {
    id: 'dashboardFitness.noFitness',
    defaultMessage:
      'To see fitness metrics here, connect a device to your VITALL account by clicking Add Device below or from within the Health Devices section.',
  },
  viewAll: {
    id: 'dashboard.metrics',
    defaultMessage: 'View All',
  },
});

function Fitness({
  loading,
  observations,
}: {
  loading: boolean;
  observations: Record<string, ObservationRecord | null>;
}) {
  const { formatMessage } = useIntl();

  return (
    <ObservationTracker
      loading={loading}
      noData={formatMessage(messages.noFitness)}
      observations={observations}
      route={ROUTES.FITNESS}
      title={formatMessage(messages.fitness)}
      viewAll={formatMessage(messages.viewAll)}
    />
  );
}

export default Fitness;
